/**
 * Spotlight stack – swipeable card deck (Tech Hunk mobile)
 */
(function () {
  const SECTION_SELECTOR = '.spotlight-stack[data-section-id]';
  const SWIPE_THRESHOLD = 90;

  function restack(cards) {
    cards.forEach((card, index) => {
      card.classList.remove('is-top', 'is-mid', 'is-back', 'swipe-left', 'swipe-right');
      card.style.transform = '';
      card.style.opacity = '';

      if (index === 0) card.classList.add('is-top');
      else if (index === 1 || index === 2) card.classList.add('is-mid');
      else card.classList.add('is-back');
    });
  }

  function bindSwipe(topCard, stack, cards) {
    let startX = 0;
    let currentX = 0;
    let dragging = false;

    function onStart(clientX) {
      if (!topCard.classList.contains('is-top')) return;
      dragging = true;
      startX = clientX;
      currentX = clientX;
      topCard.style.transition = 'none';
    }

    function onMove(clientX) {
      if (!dragging) return;
      currentX = clientX;
      const delta = currentX - startX;
      const rotate = delta * 0.06;
      topCard.style.transform = `translate(calc(-50% + ${delta}px), -50%) rotate(${6 + rotate}deg) scale(1)`;
    }

    function onEnd() {
      if (!dragging) return;
      dragging = false;
      topCard.style.transition = '';

      const delta = currentX - startX;

      if (Math.abs(delta) >= SWIPE_THRESHOLD) {
        topCard.classList.add(delta < 0 ? 'swipe-left' : 'swipe-right');

        setTimeout(() => {
          stack.appendChild(topCard);
          const nextCards = Array.from(stack.querySelectorAll('[data-spotlight-card]'));
          restack(nextCards);
          bindSwipe(nextCards[0], stack, nextCards);
        }, 280);
      } else {
        restack(cards);
      }
    }

    topCard.addEventListener(
      'touchstart',
      (e) => {
        if (e.touches.length === 1) onStart(e.touches[0].clientX);
      },
      { passive: true }
    );

    topCard.addEventListener(
      'touchmove',
      (e) => {
        if (e.touches.length === 1) onMove(e.touches[0].clientX);
      },
      { passive: true }
    );

    topCard.addEventListener('touchend', onEnd);
    topCard.addEventListener('touchcancel', onEnd);

    topCard.addEventListener('mousedown', (e) => {
      e.preventDefault();
      onStart(e.clientX);

      const onMouseMove = (ev) => onMove(ev.clientX);
      const onMouseUp = () => {
        onEnd();
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
      };

      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    });
  }

  function initSection(section) {
    if (section.dataset.spotlightReady === 'true') return;

    const stack = section.querySelector('[data-spotlight-stack]');
    if (!stack) return;

    const cards = Array.from(stack.querySelectorAll('[data-spotlight-card]'));
    if (cards.length < 2) return;

    restack(cards);
    bindSwipe(cards[0], stack, cards);

    section.dataset.spotlightReady = 'true';
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section =
      event.target.querySelector(SECTION_SELECTOR) ||
      event.target.closest(SECTION_SELECTOR);
    if (section) {
      delete section.dataset.spotlightReady;
      initSection(section);
    }
  });
})();
